export default __webpack_public_path__ + "static/media/logo2.a8015f15.png";